"use strict";
import * as signalR from "@microsoft/signalr";

export default (function () {
    $(function () {
        initCallbackNotification();
    });

    function initCallbackNotification() {

        let defaultNotification = document.querySelector(".jsCallbackNotificationDefault");
        if (defaultNotification) {
            defaultNotification.remove();

            let notificationsHolder = document.getElementById("jsNotificationsHolder");

            let callbackHiddenInput = $('#CallbackNotificationEnabled');
            let callbackEnabled = callbackHiddenInput.length > 0 ? callbackHiddenInput.val().toLowerCase() === 'true' : false;

            if (!callbackEnabled) {
                return;
            }

            const callbackConnection = new signalR.HubConnectionBuilder()
                .withUrl("/callbackNotifications")
                .withAutomaticReconnect()
                .build();

            callbackConnection.on("NotifyNewCallbackReceived", (notificationsAsString) => {
                var listOfNotifications = JSON.parse(notificationsAsString);
                listOfNotifications.map((notification) => {
                    let newNotification = defaultNotification.cloneNode(true);
                    let date = new Date(notification.Time);
                    let localTime = new Date();
                    let offset = (localTime.getTimezoneOffset() / 60) * -1;
                    date = new Date(date.setHours(date.getHours() + offset));

                    newNotification.querySelector(".jsCallbackNotificationName").innerText = notification.CustomerName;
                    newNotification.querySelector(".jsCallbackNotificationTime").innerText = ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
                    if (notification.MobileNumber != "") {
                        newNotification.querySelector(".jsCallbackNotificationJoin").href = "tel:" + notification.MobileNumber;
                    }

                    newNotification.querySelector(".jsCallbackNotificationDismiss").addEventListener("click", function () {
                        newNotification.remove();
                    });

                    newNotification.classList.remove("d-none");
                    notificationsHolder.prepend(newNotification);
                });
            });

            callbackConnection.start();
        }
    }
}());